import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  postSelect: [],
};

const setPosts = (state, action) => {
  const postList = [...state.postSelect];
  const hasItem = postList.some((item) => item.id === action.payload.id);
  if (!hasItem) {
    state.postSelect.push(action.payload);
  }
};
const removePost = (state, action) => {
  const postList = [...state.postSelect];
  const newList = postList.filter((item) => item.id != action.payload.id);
  state.postSelect = newList;
};

const clearPosts=(state)=>{
  state.postSelect=[]
}

const addAllPosts = (state, action) => {
  state.postSelect=action.payload
}
const TreeDrowpSlice = createSlice({
  name: "treeDrowp",
  initialState,
  reducers: {
    setPosts,
    removePost,
    clearPosts,
    addAllPosts
  },
});
export const { setPosts: setPostsR, removePost: removePostR,clearPosts:clearPostsR,addAllPosts:addAllPostsR } =
  TreeDrowpSlice.actions;

export default TreeDrowpSlice.reducer;
